// Captures the install prompt as early as possible. Chrome fires
// `beforeinstallprompt` once, often before React has mounted the header,
// so the button cannot rely on its own listener to catch it.

let deferredPrompt = null;
let installed = false;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener());

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredPrompt = e;
  notify();
});

window.addEventListener('appinstalled', () => {
  deferredPrompt = null;
  installed = true;
  notify();
});

export const subscribe = (listener) => {
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const getDeferredPrompt = () => deferredPrompt;

export const clearDeferredPrompt = () => {
  deferredPrompt = null;
  notify();
};

export const isStandalone = () =>
  installed ||
  window.matchMedia('(display-mode: standalone)').matches ||
  window.navigator.standalone === true;

export const getPlatform = () => {
  const ua = window.navigator.userAgent;
  // iPadOS 13+ reports itself as a Mac, so check for touch support too.
  const isIOS =
    /iPad|iPhone|iPod/.test(ua) ||
    (window.navigator.platform === 'MacIntel' && window.navigator.maxTouchPoints > 1);
  // In-app browsers (Instagram, Facebook, TikTok, ...) cannot install web apps.
  const isInAppBrowser = /FBAN|FBAV|Instagram|Line\/|Twitter|TikTok|Snapchat|LinkedInApp/i.test(ua);
  return { isIOS, isAndroid: /Android/i.test(ua), isInAppBrowser };
};

export const registerServiceWorker = () => {
  if (!('serviceWorker' in navigator) || process.env.NODE_ENV !== 'production') return;
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${process.env.PUBLIC_URL}/sw.js`)
      .catch((error) => console.error('Service worker registration failed:', error));
  });
};
